import { ApiStoreStatsResponse } from "@incendium/api";
import { analyticsService } from "Apis";

export async function getStoreStats(
  projectId: number,
): Promise<ApiStoreStatsResponse> {
  return analyticsService.analyticsServiceStoreStats({ projectId });
}
